import Vue from 'vue'
export default {
    set2022WinterTabtype (state, data) {
        state.tabtype = data;
    },

}

